export default "__VITE_ASSET__Do1r0k1Q__"